import http from '@/http'
import Router from "@/router";
import env from '@/env';
import {notifyError} from "@/components/composables/messages";

let pendingRequest = null

export const state = {
    currentUser: null,
    loading: false,
}

export const mutations = {
    setCurrentUser(state, newValue) {
        state.currentUser = newValue
    },
    setLoading(state, status) {
        state.loading = status
    }
}

export const getters = {
    loggedIn(state) {
        return !!state.currentUser && Object.keys(state.currentUser).length > 0
    }
}

export const actions = {
    // eslint-disable-next-line no-unused-vars
    init({state, dispatch}) {
        dispatch('validate')
    },

    setCurrentUser({dispatch}, token) {
        localStorage.setItem('token', token)
        return dispatch('initialize')
    },

    initialize({ dispatch }) {
        return dispatch('fetchUser', { redirectOnSuccess: true })
    },

    refresh({ dispatch }) {
        return dispatch('fetchUser', { redirectOnSuccess: false })
    },

    fetchUser({ commit, dispatch }, { redirectOnSuccess = false } = {}) {
        const token = localStorage.getItem('token')

        if (!token) {
            return this.dispatch('reset')
        }

        if (pendingRequest) {
            return pendingRequest
        }

        commit('setLoading', true)

        pendingRequest = http.get(env.apiv2 + 'show', {
            headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => {
            const apiData = response.data.data || response.data;
            const userData = apiData.user || apiData;

            commit('setCurrentUser', userData)
            
            if (redirectOnSuccess && Router.currentRoute.value?.path !== '/') {
                Router.push('/')
            }
            return response.data
        })
        .catch(error => {
            console.error(error)
            dispatch('reset')
            
            if (Router.currentRoute.value?.path !== '/login') {
                Router.push('/login');
                notifyError('Você precisa se autenticar')
            }
            return Promise.reject(error)
        })
        .finally(() => {
            commit('setLoading', false)
            pendingRequest = null
        })

        return pendingRequest
    },

    reset({ commit }) {
        localStorage.removeItem('token')
        commit('setCurrentUser', null)
    },

    logout({ dispatch }) {
        return http
            .post(env.apiv2 + 'logout')
            .catch(error => {
                console.error(error)
            })
            .finally(() => {
                dispatch('reset')
                if (Router.currentRoute.value?.path !== '/login') {
                    Router.push('/login')
                }
            });
    },
}
